export const composeHOC = (style, ui) => {
  return {
    functional: true,
    render (h, { data, children }) {
      return h({
        render (h) { return h(style, [h(ui, data, children)]); },
      });
    },
  };
};
